import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "details", "name", "address", "emails"]

  connect() {
    this.updateDetails()
  }

  updateDetails() {
    const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex]
    if (!selectedOption || !selectedOption.value) {
      this.detailsTarget.classList.add("hidden")
      return
    }

    const name = selectedOption.dataset.name
    const address = selectedOption.dataset.address
    const emails = selectedOption.dataset.emails

    this.nameTarget.textContent = name || ""
    this.addressTarget.textContent = address || ""
    this.emailsTarget.textContent = emails || ""

    this.detailsTarget.classList.remove("hidden")
  }
}
